import React, { useContext, useEffect, useState } from "react";

import { SelectField } from "@culturehq/components";
import { SelectOption, SelectValue, SelectValueWithCategory } from "@culturehq/components/dist/components/form/typings";

import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import { Trans } from "app/utils";
import { LANGUAGE_CODES } from "../utils/constants";

interface LanguageSelectFieldProps {
  availableLanguages: string[];
  activeLanguageCode?: string;
  onLanguageChange: (language: string) => void;
  onLoadFonts: (value: string) => void;
}

const LanguageSelectField: React.FC<LanguageSelectFieldProps> = ({
  availableLanguages, activeLanguageCode, onLanguageChange, onLoadFonts
}) => {
  const { data: { burnSubtitles } } = useContext(CreatomateContext);

  const [languages, setLanguages] = useState<{ label: string; value: string }[]>([]);

  useEffect(
    () => {
      setLanguages(availableLanguages.map(language => (
        { label: LANGUAGE_CODES[language], value: language }
      )));
    }, [availableLanguages]
  );

  const handleChangeLanguage = (value: null | SelectValue | SelectValueWithCategory) => {
    if (typeof value !== "string") return;

    onLoadFonts(value);
    onLanguageChange(value);
  };

  return (
    <SelectField
      className="chq-ffd-border"
      disabled={!burnSubtitles}
      name="languageSelector"
      onChange={handleChangeLanguage}
      options={languages as SelectOption[]}
      value={activeLanguageCode}
    >
      <Trans>Language</Trans>
    </SelectField>
  );
};

export default LanguageSelectField;
